import { Injectable } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { BehaviorSubject, of } from 'rxjs'
import { share, take } from 'rxjs/operators'
import { CommonService } from '../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class QuoteCartService {
  [x: string]: any
  loggedIn: boolean
  cartId
  userType

  private quoteSource = new BehaviorSubject(undefined)
  recieveCartId = this.quoteSource.asObservable()
  retainLegalEntityCollection = new BehaviorSubject({})
  retainEndUserIndustry = new BehaviorSubject('')
  quoteApplyToAllDateSource = new BehaviorSubject(undefined)
  recieveApplyToAll = this.quoteApplyToAllDateSource.asObservable()

  sendApplyToAll(date) {
    this.quoteApplyToAllDateSource.next(date)
  }

  constructor(public commonService: CommonService, private auth: AuthService) {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current')
        }
        if (this.loggedIn) {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous')
        }
      },
      (error) => {}
    )
  }

  addProduct(userType, cartId, product) {
    const urlParam = ['users', userType, 'rfqcart', cartId, 'entries']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, product)
  }

  getQuoteReason(userType) {
    const urlParam = ['users', userType, 'rfqcart', 'reasonforQuote']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }

  addProductFromCatalog(product) {
    setTimeout(() => {
      this.auth.isUserLoggedIn().subscribe(
        (success) => {
          this.loggedIn = success
          if (this.loggedIn) {
            this.userType = 'current'
            this.cartId = sessionStorage.getItem('cartId-current')
          }
          if (this.loggedIn) {
            this.userType = 'anonymous'
            this.cartId = sessionStorage.getItem('cartId-anonymous')
          }
        },
        (error) => {}
      )
    }, 100)
    const urlParam = ['users', this.userType, 'rfqcart', this.cartId, 'entries']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, product)
  }
  deleteProduct(userType, cartId, entryNumber) {
    const urlParam = [
      'users',
      userType,
      'rfqcart',
      cartId,
      'entries',
      entryNumber,
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(apiUrl)
  }
  deleteMultipleQuoteEntries(userType, cartId, data) {
    const urlParam = [
      'users',
      userType,
      'rfqcart',
      cartId,
      'cartEntries',
      'delete',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteMultipleEntries(apiUrl, { body: data })
  }
  getCart(cartId, userType) {
    let url

    let urlParam = []
    if (!cartId) {
      urlParam = ['users', userType, 'rfqcart', 'undefined']
      url = this.commonService.constructUrl(urlParam)
    } else {
      urlParam = ['users', userType, 'rfqcart', cartId]
      url = this.commonService.constructUrl(urlParam)
    }
    return this.commonService.getData_WithoutRetry(url).pipe(share())
  }
  getProduct(userType, cartId) {
    const urlParam = ['users', userType, 'rfqcart', cartId]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(apiUrl)
  }
  deleteCart(userType, cartId) {
    const urlParam = ['users', userType, 'rfqcart', cartId]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(apiUrl)
  }
  checkLogin() {
    return this.auth.isUserLoggedIn()
  }
  searchProduct(key) {
    const urlParam = ['products', 'search']
    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {
      currentPage: '0',
      pageSize: 5,
      fields: 'FULL',
      query: key,
    }
    return this.commonService.getData(url, apiParams)
  }
  updateProduct(userType, cartId, entryNumber, product) {
    const urlParam = [
      'users',
      userType,
      'rfqcart',
      cartId,
      'entries',
      entryNumber,
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.updateData(apiUrl, product)
  }
  additionalComments(userType, cartId, entryNumber, commentText) {
    const apiParams = {
      comment: commentText,
    }
    const urlParam = [
      'users',
      userType,
      'rfqcart',
      cartId,
      'entries',
      entryNumber,
      'updateComment',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, apiParams)
  }
  updateMaterialNumber(userType, cartId, entryNumber, materialNum): any {
    let url
    let urlParam = []
    const apiParams = {
      customerMaterialNumber: materialNum,
    }
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'updateMaterialNumber',
    ]

    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, apiParams)
  }
  duplicateProduct(userType, cartId, entryNumber) {
    const urlParam = [
      'users',
      userType,
      'rfqcart',
      cartId,
      'entries',
      entryNumber,
      'duplicate',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.updateData(apiUrl)
  }

  splitItemEntry(userType, cartId, entryNumber): any {
    let url
    let urlParam = []
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'splitEntry',
    ]
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, {})
  }

  dateApplyAll(userType, cartId, request) {
    const urlParam = ['users', userType, 'rfqcart', cartId, 'requestedShipDate']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, request).pipe(share())
  }

  sendCartId(cartId: string) {
    this.quoteSource.next(cartId)
  }
  getBrand(userType, cartId) {
    const urlParam = ['users', userType, 'rfqcart', cartId, 'brand']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }
  downloadQuoteCrt(userType, cartId) {
    const urlParam = ['users', userType, 'quote', cartId, 'export']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_Excel(apiUrl)
  }

  getEligibleMergeQuoteEntries(cartId) {
    const urlParams = [
      'users',
      'current',
      'rfqcart',
      cartId,
      'getEligibleMergeQuoteEntries',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }
  mergeQuoteCartEntries(cartId, mergeData) {
    const apiParams = {
      entries: mergeData,
    }
    const urlParam = ['users', 'current', 'rfqcart', cartId, 'mergeQuoteEntries']
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }
}
